var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { defaultButtonProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
var SkeletonButton = /** @class */ (function (_super) {
    __extends(SkeletonButton, _super);
    function SkeletonButton(props) {
        return _super.call(this, props) || this;
    }
    SkeletonButton.prototype.render = function () {
        var _a = this.props, active = _a.active, shape = _a.shape, rest = __rest(_a, ["active", "shape"]);
        var buttonClass = ['inline-block', 'w-px-76', 'h-px-32'];
        var shapeClass = shape == 'round' ? 'round-16' : 'rounded';
        var activeClassName = active ? 'active' : '';
        return (React.createElement(DivTag, __assign({ name: SkeletonButton.NAME }, rest),
            React.createElement(SpanTag, { atomics: buttonClass, className: "bg-gray " + shapeClass + " " + activeClassName })));
    };
    SkeletonButton.defaultButtonProps = defaultButtonProps;
    SkeletonButton.NAME = 'skeleton-button';
    SkeletonButton.displayName = 'SkeletonButton';
    return SkeletonButton;
}(Component));
export { SkeletonButton };
